import { useState } from 'react';
import Loading from "src/views/aimhi-widgets/Loading";
import Lottie from 'react-lottie';
import LoadingLottie from "src/json/loading_new.json"
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: LoadingLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const useLoading = () => {
  const [loading, setLoading] = useState(false);

  const LoadingComponent = () => (
    loading ? <Loading /> : null
  );

  const InlineLoading = () => {
    if (!loading) return null;
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Lottie options={defaultOptions} height={150} width={150} />
      </div>
    );
  };

  const SmallLoading = () => {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Lottie options={defaultOptions} height={150} width={150} />
      </div>
    );
  }
  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);

  return { LoadingComponent, SmallLoading, InlineLoading, startLoading, stopLoading, isLoading: loading };
};

export default useLoading;
